import moment from 'moment';

export const handleDescription = (description) => {
	if (description.length > 0) {
		const parsedDate = moment(description[0].date_process);
		return parsedDate.format('DD/MM/YYYY HH:mm:ss A');
	}
	return '--'
};
